import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter } from "reactstrap";

import { ModalsProps } from "@models/components/modals.model";

import ModalHeader from "../ModalHeader/ModalHeader";

const Modals: React.FC<ModalsProps> = ({
  children,
  closeModals,
  contentClassName,
  flag = true,
  footerClassName,
  footerContent,
  headerChildren,
  isModalHeader,
  modalClassName,
  onClose,
}) => {
  const [modal, setModal] = useState(true);
  const toggle = () => {
    setModal(!modal);
  };

  useEffect(() => {
    const element = document.querySelector(".modal-body") as HTMLElement | null;
    if (element) {
      element.style.padding = "0";
    }
  }, []);

  return (
    <div data-testid="modals">
      <Modal
        fullscreen={true}
        isOpen={modal}
        toggle={toggle}
        contentClassName={`fg-modal-content ${contentClassName || ""}`}
        data-testid="modal"
        onClosed={() => {
          if (onClose) onClose(false);
        }}
        modalClassName={`fg-fade-translate ${modalClassName || ""}`}
      >
        {headerChildren}

        {isModalHeader && <ModalHeader onClose={onClose} />}
        <ModalBody className="fg-modal-body" data-testid="modalBody">
          <>
            {flag && (
              <button
                className="fg-close-btn"
                aria-label="Close"
                onClick={() => {
                  if (onClose) onClose(false);
                  if (closeModals) closeModals();
                }}
              >
                <i className="fa-sharp fa-solid fa-xmark fa-xl"></i>
              </button>
            )}
            {children}
          </>
        </ModalBody>
        {footerContent && (
          <ModalFooter className={footerClassName}>{footerContent}</ModalFooter>
        )}
      </Modal>
    </div>
  );
};
export default Modals;
